"use client";

import { ChevronRight } from "lucide-react";
import * as React from "react";
import { Button } from "@/components/ui/atoms/button";
import { createPropsComparator } from "@/components/ui/utils/memo";
import { cn } from "@/lib/utils";

export type ViewToolsControlProps = {
  toolsCount: number;
  selectedCount?: number;
  indeterminate?: boolean;
  onClick: () => void;
  className?: string;
  name: string;
};

function getBubbleText(
  toolsCount: number,
  selectedCount = 0,
  indeterminate?: boolean
) {
  if (indeterminate && selectedCount > 0) {
    return `${selectedCount}/${toolsCount}`;
  }
  return String(toolsCount);
}

function ViewToolsControlImpl({
  toolsCount,
  selectedCount = 0,
  indeterminate,
  onClick,
  className,
  name,
}: ViewToolsControlProps) {
  const bubble = getBubbleText(toolsCount, selectedCount, indeterminate);

  return (
    <Button
      aria-label={`View tools in ${name}`}
      className={cn("gap-1", className)}
      data-slot="view-tools-control"
      data-testid="view-tools"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      size="sm"
      variant="outline"
    >
      <span className="text-xs leading-none">{bubble} tools</span>
      <ChevronRight className="size-3.5 transition-transform group-hover:translate-x-0.5" />
    </Button>
  );
}

export const ViewToolsControl = React.memo(
  ViewToolsControlImpl,
  createPropsComparator<ViewToolsControlProps>([
    "toolsCount",
    "selectedCount",
    "indeterminate",
    "className",
    "name",
    "onClick",
  ])
);
